export default __webpack_public_path__ + "static/media/map.3d76a244.png";